import React from "react";

import { Icon } from "../../../assets/icons/Icon";
import { formatNumber } from "../../../helpers/helpers";
import styles from "./PlanTable.module.scss";
import { TableRowProps } from "./types";

type CellType = {
  value:
    | string
    | number
    | boolean
    | React.ReactElement
    | React.ReactNode
    | null
    | undefined;
  index: React.Key | null | undefined;
};

const TableRow: React.FC<TableRowProps> = ({
  label,
  values,
  type = "text",
}) => {
  const renderCell = (
    value: CellType["value"],
    index: CellType["index"],
  ): React.ReactElement => {
    if (type === "check") {
      return (
        <div
          key={index}
          // @ts-expect-error TS2551 non-existing className
          className={`${styles.table__cell} ${styles["table__cell--check"]}`}
        >
          {value ? (
            <Icon iconName="GreenCheckmarkIcon" />
          ) : (
            <Icon iconName="RedCrossmarkIcon" />
          )}
        </div>
      );
    }

    if (value === null || value === undefined || value === "") {
      return (
        <div
          key={index}
          // @ts-expect-error TS2551 non-existing className
          className={`${styles.table__cell} ${styles["table__cell--empty"]}`}
          aria-label="No value"
        />
      );
    }

    if (type === "number" && typeof value === "number") {
      return (
        // @ts-expect-error TS2551 non-existing className
        <div key={index} className={styles.table__cell}>
          {formatNumber(value)}
        </div>
      );
    }

    return (
      // @ts-expect-error TS2551 non-existing className
      <div key={index} className={styles.table__cell}>
        {value}
      </div>
    );
  };

  return (
    <>
      {/*
       // @ts-expect-error TS2551 non-existing className */}
      <div className={styles.table__cell}>{label}</div>
      {values?.map((value, index) => renderCell(value, index))}
    </>
  );
};

export default TableRow;
